export enum PromotionPolicyType {
  NoLimit = 'NoLimit',
  DailyLimit = 'DailyLimit',
}

export const PromotionPolicyTypeString = {
  [PromotionPolicyType.NoLimit]: '무제한',
  [PromotionPolicyType.DailyLimit]: '일일 제한',
};

export enum PromotionItemPolicyType {
  Once = 'Once',
  Daily = 'Daily',
}

export const PromotionItemPolicyTypeString = {
  [PromotionItemPolicyType.Once]: '1회',
  [PromotionItemPolicyType.Daily]: '1일 1회',
};

export enum PromotionReplyOrder {
  Like = 'Like',
  Latest = 'Latest',
}

export const PromotionReplyOrderText = {
  [PromotionReplyOrder.Like]: '좋아요순',
  [PromotionReplyOrder.Latest]: '최신순',
};

export enum PromotionSlugType {
  BalanceRitto2025 = '2025-balance-ritto',
}

export const PromotionSlugTypeString = {
  [PromotionSlugType.BalanceRitto2025]: '2025-balance-ritto',
};
